import Viewer from 'viewerjs';

class SecondaryHeader {
    constructor(section) {
        this.section = section;
        this.isLightboxEnabled = this.section.dataset.lightbox === 'true';

        if (this.isLightboxEnabled) {
            this.initImageViewer();
        }
    }

    initImageViewer() {
        const images = this.section.querySelectorAll('.js-secondary-header__img');

        if (!images.length) return;

        images.forEach(image => {
            new Viewer(image, {
                toolbar: false,
                navbar: false,
                title: false,
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.js-secondary-header');

    if (!sections.length) return;

    sections.forEach(section => {
        new SecondaryHeader(section);
    });
});